module.exports = __webpack_public_path__ + "static/media/header-mrh.d4c21bb2.png";